<template>
  <div class="waterfall">
    <vue-waterfall-easy :imgsArr="Arr" ref="waterfall" @click="setParams" :loadingTimeOut="200">
      <div slot-scope="props">
        <div class="main">
          <p>{{props.value.title}}</p>
          <div class="vangrid-right">
            <span class="f1452f"><span class="font-5">￥{{props.value.price}}</span>起/年</span>
            <van-icon name="shopping-cart-o" size="14px" color="#fff" />
          </div>
          <div class="vangrid-bottom">
            <div>
              <span>热度：</span>
              <van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="props.value.hot_num" readonly />
            </div>
          </div>
        </div>
      </div>
      <div slot="loading" slot-scope="{isFirstLoad}">
        <div slot="loading" style='color:#969799;font-size:0.8rem' v-if="isFirstLoad">搜索中...</div>
      </div>
    </vue-waterfall-easy>
  </div>
</template>

<script>
  import vueWaterfallEasy from 'vue-waterfall-easy'

  export default {
    name: 'waterfall',
    props: ['file'],
    data() {
      return {
        Arr: []
      }
    },
    components: {
      vueWaterfallEasy
    },
    created() {
      this.getWater();
    },
    watch: {
      file() {
        this.Arr = [];
        this.getWater();
      }
    },
    methods: {
      getWater() {
        this.$axios.post(baseUrl + '/mobile/Oss/ossImgQuery', {
          img_base64: this.file
        }).then((res) => {
          if (res.data.code == 2) {
            for (let v of res.data.data) {
              var picObj = {
                "src": "https://backstage.jbj-china.com.cn/uploads/"
              }
              picObj["src"] += v.image;
              picObj["title"] = v.title;
              picObj["price"] = v.price;
              picObj["hot_num"] = v.hot_num;
              picObj["id"] = v.id;
              this.Arr = this.Arr.concat(picObj);
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      //跳转详情页
      setParams(event, {
        index,
        value
      }) {
        event.preventDefault()
        // 只有当点击到图片时才进行操作
        if (event.target.tagName.toLowerCase() == 'img') {
          this.$router.push({
            path: '/Detail',
            query: {
              id: value.id
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .f1452f {
    color: #f1452f;
  }

  .font-5 {
    font-size: 0.9rem;
    margin-right: 0.2rem;
  }

  .waterfall {
    position: absolute;
    width: 100%;
    top: 2rem;
    bottom: 0;
    right: 0;
    left: 0;
  }

  .main {
    padding: 0 0.5rem;
    text-align: left;
    background: #fff;
    overflow: hidden;
    color: #000;
  }

  .main p {
    margin-top: 0;
    padding-top: 0.5rem;
  }

  .main .vangrid-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .main .vangrid-right i {
    background: red;
    border-radius: 50%;
    text-align: center;
    height: 1.2rem;
    width: 1.2rem;
    line-height: 1.2rem
  }

  .main .vangrid-bottom {
    margin: 0.5rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/waterfall.vue